import React from 'react';
import { useSelector } from "react-redux";
import './AllacciamentoFognaturaCase.scss';
import CaseGenerator from "../../../CaseGenerator/CaseGenerator";
import {CaseForms, UserRoleEnum} from "../../../../helpers/enums";
import { SwitchUser } from "../../../../helpers/helpers";
import { useTranslation } from "react-i18next";
import digitalizzazioneCustomModalSuccess
  from "../../../CaseGenerator/custom-success-modal/digitalizzazioneCustomModalSuccess";

const AllacciamentoFognaturaCase = () => {
  const auth = useSelector((state) => state.auth);
  const {user} = auth;
  const userProfile = SwitchUser(auth);
  const role = userProfile ? userProfile.role : null;
  const { t } = useTranslation();
  const blockForm =
    userProfile.isCondominiumAdminDisabled && role === UserRoleEnum.CONDOMINIUM_ADMIN;
  return (
    <div
      className="AllacciamentoFognaturaCase"
      data-testid="AllacciamentoFognaturaCase"
    >
      <CaseGenerator
        type={CaseForms.Fognatura}
        block={blockForm}
        signDigital={user.role !== 'MUNICIPAL_OPERATOR'} // this is mandatory if you want custom success modal
        excludeSteps={user.role === 'MUNICIPAL_OPERATOR' ? [8]: []}
        blockText={blockForm && t("associate-contract.block-view")}
        successModalCustom={
          (props) => digitalizzazioneCustomModalSuccess({t:t,content: "cases.digitalization.success", ...props})
        }
      />
    </div>
  );
};

AllacciamentoFognaturaCase.propTypes = {};

export default AllacciamentoFognaturaCase;

